import type { PraxaDesktopAccountControlsState } from "@praxa/platform-contracts";

export type PraxaPlanName = NonNullable<
  PraxaDesktopAccountControlsState["snapshot"]
>["plan"]["name"];

const PRAXA_PLAN_LABELS = {
  free: "Free",
  plus: "Plus",
  pro: "Pro",
  max: "Max",
  business: "Business",
  admin: "Admin",
} as const satisfies Record<PraxaPlanName, string>;

export function praxaPlanLabel(planName: PraxaPlanName): string {
  return PRAXA_PLAN_LABELS[planName];
}

export function resolvePraxaSidebarPlanLabel(input: {
  readonly accountId: string;
  readonly controls: PraxaDesktopAccountControlsState | null;
  readonly loading: boolean;
}): string {
  const snapshot = input.controls?.snapshot;
  if (
    snapshot !== null &&
    snapshot !== undefined &&
    input.controls?.accountId === input.accountId &&
    snapshot.accountId === input.accountId
  ) {
    const label = `${praxaPlanLabel(snapshot.plan.name)} plan`;
    return snapshot.plan.active ? label : `${label} · Inactive`;
  }

  return input.loading || input.controls?.status === "loading"
    ? "Loading plan…"
    : "Plan unavailable";
}
